import { gql, TypedDocumentNode } from "@apollo/client";

import {
  Role,
  ApiKey,
  ApiKeyRoleBinding,
  ApiKeyRoleBindingInput,
  MutationApiKeyRoleBindingBatchCreateArgs,
  Space,
} from "types/generated";

type ApiKeyRoleBindingsWithRolesData = {
  roles: Array<Pick<Role, "id" | "name" | "slug">>;
  apiKey: Pick<ApiKey, "id"> & {
    apiKeyRoleBindings: Array<
      Pick<ApiKeyRoleBinding, "id" | "apiKeyID"> & {
        space: Pick<Space, "id" | "name">;
        role: Pick<Role, "id" | "name" | "isSystem">;
      }
    >;
  };
};

type ApiKeyRoleBindingUpdateData = {
  apiKeyRoleBindingUpdate: Pick<ApiKeyRoleBinding, "id">;
};

type ApiKeyRoleBindingBatchCreateData = {
  apiKeyRoleBindingBatchCreate: Pick<ApiKeyRoleBinding, "id">[];
};

export const API_KEY_ROLE_BINDINGS_WITH_ROLES: TypedDocumentNode<ApiKeyRoleBindingsWithRolesData> = gql`
  query ApiKeyRoleBindingsWithRoles($apiKeyId: ID!) {
    apiKey(id: $apiKeyId) {
      id
      apiKeyRoleBindings {
        id
        apiKeyID
        space {
          id
          name
        }
        role {
          id
          name
          isSystem
        }
      }
    }
    roles {
      id
      name
      slug
    }
  }
`;

export const API_KEY_ROLE_BINDING_UPDATE: TypedDocumentNode<
  ApiKeyRoleBindingUpdateData,
  { id: string; input: ApiKeyRoleBindingInput }
> = gql`
  mutation ApiKeyRoleBindingUpdate($id: ID!, $input: ApiKeyRoleBindingInput!) {
    apiKeyRoleBindingUpdate(id: $id, input: $input) {
      id
    }
  }
`;

export const API_KEY_ROLE_BINDING_BATCH_CREATE: TypedDocumentNode<
  ApiKeyRoleBindingBatchCreateData,
  MutationApiKeyRoleBindingBatchCreateArgs
> = gql`
  mutation ApiKeyRoleBindingBatchCreate($input: ApiKeyRoleBindingBatchInput!) {
    apiKeyRoleBindingBatchCreate(input: $input) {
      id
    }
  }
`;
